import React from 'react'
import PropTypes from 'prop-types'

import { FormattedMessage } from 'react-intl'

import Locale from './locale'
import Styles from './styles.scss'


export default function TCFLabel({ showCount = true, title, vendorCount }) {
  return (
    <div className={ Styles.root }>
      <div className="tcfVendorCountTitle">
        { title }
      </div>

      {
        renderCount({
          showCount,
          vendorCount,
        })
      }
    </div>
  )
}

TCFLabel.propTypes = {
  title: PropTypes.string.isRequired,

  showCount: PropTypes.bool,
  vendorCount: PropTypes.number,
}

function renderCount({ showCount, vendorCount }) {
  if ( !showCount ) {
    return null
  }

  const values = {
    vendorCount: vendorCount ?? 0,
  }

  return (
    <div className={ Styles.vendorCount }>
      <FormattedMessage
        { ...Locale.vendors }
        values={ values }
      />
    </div>
  )
}
